'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var common = require('./common.js');
var red = require('./red.js');
var pink = require('./pink.js');
var purple = require('./purple.js');
var deepPurple = require('./deepPurple.js');
var indigo = require('./indigo.js');
var blue = require('./blue.js');
var lightBlue = require('./lightBlue.js');
var cyan = require('./cyan.js');
var teal = require('./teal.js');
var green = require('./green.js');
var lightGreen = require('./lightGreen.js');
var lime = require('./lime.js');
var yellow = require('./yellow.js');
var amber = require('./amber.js');
var orange = require('./orange.js');
var deepOrange = require('./deepOrange.js');
var brown = require('./brown.js');
var grey = require('./grey.js');
var blueGrey = require('./blueGrey.js');



exports.common = common;
exports.red = red;
exports.pink = pink;
exports.purple = purple;
exports.deepPurple = deepPurple;
exports.indigo = indigo;
exports.blue = blue;
exports.lightBlue = lightBlue;
exports.cyan = cyan;
exports.teal = teal;
exports.green = green;
exports.lightGreen = lightGreen;
exports.lime = lime;
exports.yellow = yellow;
exports.amber = amber;
exports.orange = orange;
exports.deepOrange = deepOrange;
exports.brown = brown;
exports.grey = grey;
exports.blueGrey = blueGrey;
